import { render, staticRenderFns } from "./AdjustmentReasonType.vue?vue&type=template&id=6ea2cbc8&scoped=true"
import script from "./AdjustmentReasonType.vue?vue&type=script&lang=js"
export * from "./AdjustmentReasonType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2cbc8",
  null
  
)

export default component.exports